import React, { createRef, useRef, useEffect, useState } from 'react';
import * as THREE from 'three';
import { Canvas, extend, useFrame } from '@react-three/fiber';

// components
import WorldMesh from './WorldMesh/WorldMesh';
import CameraControls from './CameraControls/CameraControls';

// media
import acreMapPlaceholderLogo from '../../media/acre-map-placeholder.svg';

function AcreMap() {
    let mapContainerRef = useRef();

    // useEffect(() => {
    //   // connect to sandbox
    //   var testSocket = new WebSocket('wss://api.sandbox.game/ws/map');
    //   window.testSocket = testSocket;
    //   //api.sandbox.game/ws/map
    //   testSocket.onopen = () => {
    //     console.log('connected to sandbox');
    //   }
    //   testSocket.onmessage = (event) => {
    //     console.log('message from sandbox', event);
    //   }
    //   testSocket.onclose = () => {
    //     console.log('disconnected from sandbox');
    //   }
    // });
    
    return (
      <div className="absolute top-0 left-0 right-0 bottom-0" ref={mapContainerRef}>
        <Canvas>
            <ambientLight />
            <pointLight position={[10, 10, 10]} />
            <WorldMesh position={[0, 0, 0]} />
            <WorldMesh position={[3, 0, 0]} />
            <WorldMesh position={[6, 0, 0]} />
            <CameraControls />
        </Canvas>
    </div>
    )
}
export default AcreMap;